<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>

<template>
    <VCol
        v-bind="$attrs"
        class="b-col"
    >
        <slot />
    </VCol>
</template>
